import React from "react";
import { Link } from "react-router-dom";
import { useBranding } from "@/context/BrandingContext";
import { isTruthyFlag, isExternalUrl } from "@/lib/storefrontContent";

/* Announcement Bar — konten 100% tenant (settings.branding.storefront).
   Tidak dirender bila nonaktif atau teks kosong. Tanpa klaim default. */
export function AnnouncementBar() {
  const { branding } = useBranding();
  const sf = branding.storefront || {};
  const text = (sf.announcement_text || "").trim();
  if (!isTruthyFlag(sf.announcement_enabled) || !text) return null;
  const link = (sf.announcement_link || "").trim();
  const inner = <span className="gcp-announcement-text">{text}</span>;
  return (
    <div className="gcp-announcement" role="region" aria-label="Pengumuman toko" data-testid="announcement-bar">
      <div className="storefront-container flex items-center justify-center min-h-9 py-1.5 text-center">
        {link ? (
          isExternalUrl(link) ? (
            <a href={link} target="_blank" rel="noopener noreferrer" className="gcp-announcement-link" data-testid="announcement-link">{inner}</a>
          ) : (
            <Link to={link} className="gcp-announcement-link" data-testid="announcement-link">{inner}</Link>
          )
        ) : inner}
      </div>
    </div>
  );
}
